var _path, _path2, _path3, _g, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1300,
    height: 518,
    viewBox: "0 0 1300 518",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M549.613 93H87.9497C66.4515 93 49 110.451 49 131.865V386.05C49 407.549 66.4515 425 87.9497 425H549.698C571.196 425 588.648 407.549 588.563 386.135V131.865C588.563 110.451 571.112 93 549.613 93ZM334.378 347.185H282.53V246.017L230.681 310.849L178.832 246.017V347.185H126.815V170.815H178.664L230.512 235.647L282.361 170.815H334.21V347.185H334.378ZM448.445 349.798L370.63 259H422.479V170.815H474.328V259H526.176L448.445 349.798Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M857 68C857 54.1929 868.193 43 882 43H1066.67C1068.55 43 1070.43 42.7878 1072.26 42.3674L1226.41 7.0149C1242.07 3.4243 1257 15.3192 1257 31.3823V485.043C1257 501.443 1241.48 513.401 1225.62 509.215L1072.64 468.828C1070.55 468.278 1068.41 468 1066.26 468H882C868.193 468 857 456.807 857 443V68Z",
    fill: "#C75B5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M857 68C857 54.1929 868.193 43 882 43H1068V468H882C868.193 468 857 456.807 857 443V68Z",
    fill: "#E85353"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_301_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M915.091 317V200.636H954.409C963.538 200.636 971 202.284 976.795 205.58C982.629 208.837 986.947 213.25 989.75 218.818C992.553 224.386 993.955 230.598 993.955 237.455C993.955 244.311 992.553 250.542 989.75 256.148C986.985 261.754 982.705 266.223 976.909 269.557C971.114 272.852 963.689 274.5 954.636 274.5H926.455V262H954.182C960.432 262 965.451 260.92 969.239 258.761C973.027 256.602 975.773 253.686 977.477 250.011C979.22 246.299 980.091 242.114 980.091 237.455C980.091 232.795 979.22 228.629 977.477 224.955C975.773 221.28 973.008 218.402 969.182 216.318C965.356 214.197 960.28 213.136 953.955 213.136H929.182V317H915.091ZM1052.56 317H1016.65V200.636H1054.15C1065.44 200.636 1075.1 202.966 1083.13 207.625C1091.16 212.246 1097.32 218.894 1101.6 227.568C1105.88 236.205 1108.02 246.545 1108.02 258.591C1108.02 270.712 1105.86 281.148 1101.54 289.898C1097.22 298.61 1090.93 305.314 1082.68 310.011C1074.42 314.67 1064.38 317 1052.56 317ZM1030.74 304.5H1051.65C1061.27 304.5 1069.25 302.644 1075.57 298.932C1081.9 295.22 1086.62 289.936 1089.72 283.08C1092.83 276.223 1094.38 268.061 1094.38 258.591C1094.38 249.197 1092.85 241.11 1089.78 234.33C1086.71 227.511 1082.13 222.284 1076.03 218.648C1069.93 214.973 1062.34 213.136 1053.24 213.136H1030.74V304.5ZM1131.65 317V200.636H1201.43V213.136H1145.74V252.455H1196.2V264.955H1145.74V317H1131.65Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M823.425 266.425C827.525 262.324 827.525 255.676 823.425 251.575L756.603 184.754C752.503 180.653 745.854 180.653 741.754 184.754C737.653 188.854 737.653 195.503 741.754 199.603L801.151 259L741.754 318.397C737.653 322.497 737.653 329.146 741.754 333.246C745.854 337.347 752.503 337.347 756.603 333.246L823.425 266.425ZM629 269.5H816V248.5H629V269.5Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_301_37",
    x: 911.091,
    y: 200.636,
    width: 294.335,
    height: 124.364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_37"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_37",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.19bf579d3e1f805686121a2ffd9f14bc.svg";
export { ForwardRef as ReactComponent };